import React from 'react';
import DaoPageComponent from '../../components/dao-page-components';

const DaoPage = () => {
  return (
    <>
      <DaoPageComponent />
    </>
  )
}

export default DaoPage;
